<template>
  <div
    :class="$style.pills"
  >
    <slot />
  </div>
</template>

<script>
export default {
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.pills {
  display: table;
  width: 100%;
  // table-layout: fixed;
  // display: block;

  > a, > button {
    display: inline-block;
    background-color: var(--bg-3);
    color: var(--typo-1);
    border: 1px solid;
    border-color: var(--border-2);
    padding: map-get($spacers, 1) map-get($spacers, 2);
    text-align: center;
    cursor: pointer;

    &:not(:first-child) {
      border-left: transparent;
    }

    &:first-child {
      @include border-left-radius($border-radius);
    }
    &:last-child {
      @include border-right-radius($border-radius);
    }

    &:global(.active) {
      color: var(--white);
      background-color: map-get($blue-shades, 300);
      border-color: map-get($blue-shades, 400);
      position: relative;
    }

    &:focus {
      outline: 0;
    }
  }
}
</style>
/// #endif
